import React from "react";
import { connect } from "react-redux";

// HOC Modal no mesmo padrão do projeto
import Modal from "../../hocs/Modal";

// Styles
import { Row } from "../../styles/align";
import { StyleIdleWarning } from "./style";

// Actions
import { modalIdleWarningClose } from "../../actions/modals";

function IdleWarning({ seconds, modalIdleWarningClose }) {
  const handleStay = () => {
    try { localStorage.setItem("lastActivityAt", String(Date.now())); } catch (e) {}
    modalIdleWarningClose();
    if (typeof window.focus === "function") window.focus();
  };

  return (
    <StyleIdleWarning>
      <Row>
        <h2>Sessão inativa</h2>
        <p>
          Você será desconectado por inatividade em <strong>{Math.max(0, Number(seconds) || 0)}s</strong>.
        </p>
        <div className="actions">
          {/* a funcionalidade padrão do aviso nao depende do botão, mas se por algum motivo o auto-close nao funcionar, fallback no botao */}
          <button type="button" className="btn" onClick={handleStay}>
            Continuar conectado
          </button>
        </div>
      </Row>
    </StyleIdleWarning>
  );
}

const mapStateToProps = (state) => ({
  // Só precisamos do contador, o "show" vem do Modals/index.jsx via props
  seconds: state.modals.modalIdleWarningSeconds,
});

// Componente conectado + HOC Modal
export default Modal(connect(mapStateToProps, { modalIdleWarningClose })(IdleWarning));
